import { Injectable } from '@angular/core';
import {
  sendNotificationAssignTask,
  sendNotificationAssignTaskSuccess,
} from '@modules/tasks/store/tasks.actions';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { TasksService } from '@shared/services/tasks.service';
import { of } from 'rxjs';
import { switchMap, map, catchError, filter } from 'rxjs/operators';
import { NotificationsService } from '@shared/services/notifications.service';
import { completeTaskFail, createTaskSuccess, removeTaskSuccess, removeTask } from 'mojo-tasks';

@Injectable()
export class TasksEffects {
  createTaskSuccessWrapper$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createTaskSuccess),
      filter(({ task }) => !!task.assignedUserId),
      map(({ task }) =>
        sendNotificationAssignTask({
          entityType: task.entityType,
          entityId: task.entityId,
          payload: task,
          entityName: task.entityName,
          assignedUserPhotoId: task.assignedUserPhotoId,
        }),
      ),
    ),
  );
  sendNotificationTask$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendNotificationAssignTask),
      switchMap(({ entityType, entityId, payload, entityName, assignedUserPhotoId }) =>
        this.notificationService
          .sendNotificationTask(entityType, entityId, payload, entityName, assignedUserPhotoId)
          .pipe(
            map(() => sendNotificationAssignTaskSuccess()),
            catchError((error) => of(completeTaskFail({ error }))),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private tasksService: TasksService,
    private notificationService: NotificationsService,
  ) {}
}
